import React, { useCallback, useState } from 'react';
import { Field, Form } from 'react-final-form';
import flow from 'lodash.flow';
import { connect } from 'react-redux';

import { i18n, withTranslation } from '../../i18n';
import API from '../../services/API';
import * as formValidators from '../../utils/formValidation';
import Button from '../../components/UI/Button';
import Input from '../../components/Forms/Input';
import { setToken } from '../../services/Auth/actions';
import AuthService from '../../services/Auth';
import { routerPush } from '../../utils/router';

const RegisterWithEmailForm = ({ t, setToken }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFormSubmit = useCallback(async formValues => {
    setIsSubmitting(true);

    const apiValues = {
      email: formValues.email.trim(),
      first_name: formValues.firstName.trim(),
      last_name: formValues.lastName.trim(),
      password: formValues.password.trim(),
      language: i18n.language,
    };

    let response;
    try {
      response = await API.fetch(undefined, '/auth/register-with-email', apiValues);
    } catch (error) {
      setIsSubmitting(false);
      if (error.body && error.body.errors) {
        return formValidators.translateError(error.body.errors);
      }
      return;
    }

    AuthService.storeToken(response.token);
    setToken(response.token);
    routerPush(`/profile`);
  }, []);

  const validateForm = useCallback(formValues => {
    const errors = {};

    formValidators.required(formValues, errors, 'email');
    formValidators.required(formValues, errors, 'firstName');
    formValidators.required(formValues, errors, 'lastName');
    formValidators.required(formValues, errors, 'password');
    formValidators.required(formValues, errors, 'confirmPassword');

    if (!errors.password && !errors.confirmPassword && formValues.password !== formValues.confirmPassword) {
      errors.confirmPassword = t('error.passwordsNotEqual');
    }

    return errors;
  }, []);

  return (
    <Form
      onSubmit={handleFormSubmit}
      validate={validateForm}
      render={({ handleSubmit, pristine, invalid, values, errors }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Field component={Input} className="mb-1" type="email" name="email" label={t('emailAddress')} required />
            <Field component={Input} className="mb-1" name="firstName" label={t('firstName')} required />
            <Field component={Input} className="mb-1" name="lastName" label={t('lastName')} required />
            <Field component={Input} className="mb-1" type="password" name="password" label={t('password')} required />
            <Field
              component={Input}
              className="mb-1"
              type="password"
              name="confirmPassword"
              label={t('confirmPassword')}
              required
            />
            <Button level="primary" type="submit" processing={isSubmitting} fullWidth>
              {t('join')}
            </Button>
          </form>
        );
      }}
    />
  );
};

const mapDispatchToProps = {
  setToken,
};

export default flow(
  connect(
    null,
    mapDispatchToProps,
  ),
  withTranslation('common'),
)(RegisterWithEmailForm);
